<template>
  <div>
    <v-dialog v-model="viewerdialog" persistent width="1350">
      <v-toolbar dark dense class="header">
        <v-icon>mdi-account-edit</v-icon>
        <span class="ml-3">View / Edit Access</span>

        <v-spacer></v-spacer>
        <v-btn class text dark @click="viewerdialog = false">
          <v-icon color="white" small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="overflow-hidden">
        <v-divider></v-divider>
        <v-form ref="formnew">
          <v-row class="mt-3 ml-2 mr-2">
            <v-col cols="12" lg="4" xl="4" md="4" sm="12" xs="12">
              <v-row>
                <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
                  <v-text-field
                    label="Name"
                    v-model="userListViewer.name"
                    outlined
                    dense
                    v-on:keypress="isLetter($event)"
                    maxlength="25"
                    @keydown.space="preventLeadingSpace"
                    :rules="[(v) => !!v || 'Required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
                  <v-text-field
                    readonly
                    label="E-mail"
                    v-model="userListViewer.email_id"
                    outlined
                    dense
                    :rules="[
                      (v) => !!v || ' E-mail is required ',
                      (v) => /.+@.+/.test(v) || ' E-mail must be valid ',
                    ]"
                    @keydown.space="preventLeadingSpace"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
                  <v-text-field
                    label="Contact Number"
                    :rules="[
                      (v) => !!v || 'Required',
                      (v) =>
                        /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9 +-]{0,64}$/.test(
                          v
                        ) || 'Invalid',
                      (v) => (v && v.length < 11) || 'Invalid Contact Number',
                      (v) => (v && v.length > 8) || 'Invalid Contact Number',
                    ]"
                    prefix="+60"
                    maxlength="10"
                    v-model="userListViewer.mobile_no"
                    outlined
                    dense
                    @keydown.space="preventLeadingSpace"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
                  <v-text-field
                    label="Designation"
                    v-model="userListViewer.designation"
                    outlined
                    dense
                    @keydown.space="preventLeadingSpace"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
                  <v-autocomplete
                    label="Department"
                    v-model="department"
                    item-value="department_id"
                    item-text="department_name"
                    :items="getdepartmentlist"
                    outlined
                    chips
                    dense
                    multiple
                    required
                    :rules="[(v) => !!v || 'Required']"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="12" lg="8" xl="8" md="8" sm="12" xs="12">
              <v-card-title class="mt-n3">Account Permissions</v-card-title>
              <v-data-table
                :headers="headers1"
                dense
                class="mx-2"
                hide-default-footer
                :items="getUserAccesslist"
              >
                <template v-slot:[`item.module_name`]="{ item }">
                  <span class="caption">{{ item.module_name }}</span>
                </template>
                <template v-slot:[`item.has_viewer`]="{ item }">
                  <v-simple-checkbox
                    :disabled="is_root_user == 1"
                    v-if="item.element.has_viewer == '1'"
                    v-model="item.has_viewer"
                    color="primary"
                    v-ripple
                    @click="check(item)"
                  ></v-simple-checkbox>
                  <span dense v-if="item.element.has_viewer == '0'">NA</span>
                </template>
                <template v-slot:[`item.has_maker`]="{ item }">
                  <v-simple-checkbox
                    v-if="item.element.has_maker == '1'"
                    color="primary"
                    v-model="item.has_maker"
                    :disabled="!item.has_viewer || is_root_user == 1"
                  ></v-simple-checkbox>
                  <span dense v-if="item.element.has_maker == '0'">NA</span>
                </template>
                <template v-slot:[`item.has_checker`]="{ item }">
                  <v-simple-checkbox
                    v-if="item.element.has_checker == '1'"
                    v-model="item.has_checker"
                    :disabled="!item.has_viewer || is_root_user == 1"
                    color="primary"
                  ></v-simple-checkbox>
                  <span dense v-if="item.element.has_checker == '0'">NA</span>
                </template>
                <template v-slot:[`item.has_approver`]="{ item }">
                  <v-simple-checkbox
                    v-if="item.element.has_approver == '1'"
                    v-model="item.has_approver"
                    :disabled="!item.has_viewer || is_root_user == 1"
                    color="primary"
                  ></v-simple-checkbox>
                  <span dense v-if="item.element.has_approver == '0'">NA</span>
                </template>
                <template v-slot:[`item.has_super_access`]="{ item }">
                  <v-simple-checkbox
                    v-if="item.element.has_super_access == '1'"
                    v-model="item.has_super_access"
                    :disabled="!item.has_viewer || is_root_user == 1"
                    color="primary"
                  ></v-simple-checkbox>
                  <span dense v-if="item.element.has_super_access == '0'"
                    >NA</span
                  >
                </template>
                <template v-slot:[`item.has_download`]="{ item }">
                  <v-simple-checkbox
                    v-if="item.element.has_download == '1'"
                    v-model="item.has_download"
                    :disabled="!item.has_viewer || is_root_user == 1"
                    color="primary"
                  ></v-simple-checkbox>
                  <span dense v-if="item.element.has_download == '0'">NA</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row justify="center">
              <v-spacer />
              <v-btn
                :disabled="is_root_user == 1"
                class="primary mr-5 white--text mt-8"
                :loading="isLoading"
                medium
                @click="updateChanges()"
              >
                <v-icon class="mr-2 ml-n2">mdi-content-save-settings</v-icon
                >Save Changes
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-form>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="errordialog" persistent width="400">
      <v-toolbar dark dense class="primary">
        <v-toolbar-title class="white--text titcss">Root User</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class text dark @click="errordialog = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card flat height="100" class="red--text overflow-hidden">
        <v-row align="center " justify="center" class="mt-10">
          <b> This user has Full Access</b>
        </v-row>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  props: {
    is_root_user: Number,
    department_array: Array,
    getdepartmentlist: Array,
    // show: Number,
  },
  data: () => ({
    errordialog: false,
    userListViewer: {
      departement_name: "",
    },
    department: [],
    ccode: "60",
    viewerdialog: false,
    name: null,
    email: null,
    desig: null,
    cont: null,
    makedisabled: false,
    makedisabledapprover1: false,
    makedisabledapprover2: false,
    isLoading: false,
    count: 0,
    headers: [
      { text: "NAME", value: "Name" },
      { text: "CONTACT NUMBER", value: "Cont" },
      { text: "EMAIL", value: "Email" },
    ],
    desserts: [
      {
        Name: "Anusha",
        Cont: "9898999999",
        Email: "anusha@mobil80.com",
      },
      {
        Name: "Athish",
        Cont: "59595959599",
        Email: "athish@mobil80.com",
      },
      {
        Name: "Guru",
        Cont: "58555566669",
        Email: "guru@mobil80.com",
      },
    ],

    headers1: [
      { text: "SECTION", value: "module_name" },
      { text: "VIEWER", value: "has_viewer" },
      { text: "MAKER", value: "has_maker" },
      { text: "APPROVER 1", value: "has_checker" },
      { text: "APPROVER 2", value: "has_approver" },
      { text: "SUPER ACCESS", value: "has_super_access" },
      { text: "DOWNLOADER", value: "has_download" },
    ],
    getUserAccesslist: [],
    // rules: {
    //   email: [
    //     (v) => !!v || "E-mail is required",
    //     (v) => /.+@.+/.test(v) || "E-mail must be valid",
    //   ],
    // },
  }),
  watch: {
    viewerdialog(val) {
      // console.log("val", val);
      if (val == true) {
        this.department = this.getdepartmentlist
          .map((item) => {
            if (
              this.department_array.filter(
                (dept) =>
                  Number(dept.department_id) == Number(item.department_id)
              ).length == 0
            )
              item = false;
            return item.department_id;
          })
          .filter(Boolean);
        this.count = 1;
      }
      if (val == false) {
        this.count = 0;
      }
    },
    // show(val) {
    //   console.log(val);
    // },
  },

  methods: {
    updateChanges() {
      if (this.$refs.formnew.validate()) {
        this.createadmin();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Fill the Fields",
          color: "red",
        });
      }
    },
    check(item) {
      //for unchecking
      if (item.has_viewer == false) {
        item.has_maker = false;
        item.has_checker = false;
        item.has_approver = false;
        item.has_super_access = false;
        item.has_download = false;
      }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Z a-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    async getUserAccessById() {
      // this.adminacces();
      //  console.log("this.userListViewer.userid", this.userListViewer.userid);
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GUSR_ACCESS",
          user_id: this.userListViewer.userid,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        if (responseData.data.status == "00") {
          // this.viewerdialog = true;
          // this.adminacces();
          var self = this;
          var res = responseData.data.data;
          // console.log(res, "backend res");

          res.forEach(function (ele) {
            //for checkbox
            ele.has_viewer = ele.has_viewer == "1" ? true : false;
            ele.has_maker = ele.has_maker == "1" ? true : false;
            ele.has_checker = ele.has_checker == "1" ? true : false;
            ele.has_approver = ele.has_approver == "1" ? true : false;
            ele.has_super_access = ele.has_super_access == "1" ? true : false;
            ele.has_download = ele.has_download == "1" ? true : false;

            // console.log(ele.has_viewer);
            //for disabling other checkboxes if has_viewer=0
            self.makedisabled = ele.has_viewer == true ? false : true;
            self.makedisabledapprover1 = ele.has_viewer == true ? false : true;
            self.makedisabledapprover2 = ele.has_viewer == true ? false : true;

            ele.element = "";
          });
          this.adminacces();
          this.getUserAccesslist = res;
          // this.viewerdialog = true;
          // console.log(
          //   "this.getUserAccesslist  sdfafafdadasdasdasdasd",
          //   this.getUserAccesslist
          // );
        }
      }
      // else {
      //   this.adminacces();
      //   this.getUserAccesslist = res;
      //   this.viewerdialog = true;
      //this.errordialog = true;
      // this.$store.commit("snackbar/showMessage", {
      //   content: responseData.data.status_msg,
      //   color: "red",
      // });
      // }
    },
    async adminacces() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GMODULES",
          module_type: "2",
        },
      };

      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var dataarray = [];
          dataarray = responseData.data.data;

          if (this.getUserAccesslist.length > 0) {
            for (let i = 0; i < this.getUserAccesslist.length; i++) {
              this.getUserAccesslist[i].element = dataarray[i];
            }
          } else {
            const self = this;
            this.getUserAccesslist = [];
            dataarray.forEach((data) => {
              self.getUserAccesslist.push(data);
            });
          }
          if (this.count == 0) {
            this.viewerdialog = true;
          } else if (this.count == 1) {
            this.viewerdialog = false;
          }
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
      }
    },
    createadmin() {
      // console.log("this.getUserAccesslist ", this.getUserAccesslist);
      var outputarray = [];
      var self = this;
      self.getUserAccesslist.forEach(function (ele) {
        outputarray.push({
          module_id: ele.element.moduleid,
          has_viewer: ele.has_viewer == true ? 1 : 0,
          has_maker: ele.has_maker == true ? 1 : 0,
          has_checker: ele.has_checker == true ? 1 : 0,
          has_approver: ele.has_approver == true ? 1 : 0,
          has_super_access: ele.has_super_access == true ? 1 : 0,
          has_download: ele.has_download == true ? 1 : 0,
        });
      });
      //console.log("outputarray", outputarray);
      this.callingcreateadminapi(outputarray);
    },

    async callingcreateadminapi(data) {
      this.isLoading = true;
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CREATEU",
          user_details: {
            corp_id: this.$store.getters.get_corpid,
            name: this.userListViewer.name,
            email_id: this.userListViewer.email_id,
            mobile_no: this.userListViewer.mobile_no,
            ccode: this.userListViewer.ccode,
            designation: this.userListViewer.designation,
            department_id: this.department,
            user_id: this.userListViewer.userid,
          },
          module_access: data,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("res", responseData);

      if (responseData.data.status == "00") {
        this.isLoading = false;
        this.count = 1;
        this.getUserAccessById();
        this.$emit("backChild");

        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });

        // this.viewerdialog = false;
      } else {
        // this.firstuserdialog = true;
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }

      // console.log("sdgs", responseData);
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
  },
};
</script>

<style></style>
